import { c as _c } from "react/compiler-runtime";
import CkEditorCSRRenderer from '@/components/elementary/CkEditorRenderer/CkEditorCSRRenderer';
import Heading from '@/components/typography/Heading';
import { cn } from '@/lib/styles';
import type { GridCardProps } from '@/types/general';
import type { ServerRenderedEntry } from '@/types/helpers';
import styles from './AppsCard.module.css';
import { TileIcon } from './shared/TileIcon';
import { TileLink } from './shared/TileLink';
type AppsCardProps = ServerRenderedEntry<GridCardProps> & {
  iconClassName?: string;
};
export function AppsCard(t0) {
  const $ = _c(19);
  const {
    icon,
    title,
    description,
    link,
    serverProcessedHtmlDescription,
    iconClassName
  } = t0;
  let t1;
  if ($[0] !== icon || $[1] !== iconClassName) {
    t1 = icon?.media?.url && <TileIcon icon={icon} size="small" iconClassName={iconClassName} />;
    $[0] = icon;
    $[1] = iconClassName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== title) {
    t2 = title && <Heading tag="h3" className={cn("text-left w-full", styles["apps-card-title"])}>{title}</Heading>;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="flex flex-col gap-4 w-full">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== description || $[9] !== serverProcessedHtmlDescription) {
    t4 = serverProcessedHtmlDescription ? serverProcessedHtmlDescription : <CkEditorCSRRenderer className="group-hover:opacity-0 transition-opacity duration-200" variant="textOnly" htmlContent={description} context="apps-card" defaultTypography="bodySmall" />;
    $[8] = description;
    $[9] = serverProcessedHtmlDescription;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== link) {
    t5 = link && <TileLink className="gap-1 absolute top-0 w-full opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100 transition-opacity duration-200" link={link} />;
    $[11] = link;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <div className="relative h-full flex flex-col">{t4}{t5}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t3 || $[17] !== t6) {
    t7 = <div className="flex flex-col p-4 w-full h-full gap-1">{t3}{t6}</div>;
    $[16] = t3;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}